import {Observable} from 'rxjs';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {Filter, SimpleUnit} from '@core/interfaces/system/system-common';
import {FaultIndicationDashboardData, LatestModelStatus} from './live';

export interface InsulationMoistureUnits {
    paperMoistureUnit: SimpleUnit;
}

export abstract class InsulationMoistureService {
    abstract getInsulationMoistureUnits(): Observable<InsulationMoistureUnits>;

    abstract getInsulationMoistureDatasource(id: string, filter: Filter[]): Observable<DataSource>;

    abstract getCountResults(id: string, uploadTime?: string): Observable<number>;

    abstract getInsulationMoistureLatestModelStatus(id: string, uploadTime?: string): Observable<LatestModelStatus>;

    abstract getInsulationMoistureDashboardData(
        id: string,
        uploadTime?: string,
    ): Observable<FaultIndicationDashboardData>;
}
